/**
 * Formats file size in bytes to human readable format
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";

  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
}

/**
 * Heuristic check to detect if a URL points to a PDF.
 * - Matches .pdf extension in pathname
 * - Checks query for content_type=application/pdf (ActiveStorage style)
 * Falls back to a simple substring check if URL parsing fails.
 */
export function isPdfUrl(urlStr: string | null | undefined): boolean {
  if (!urlStr) return false;
  try {
    const url = new URL(urlStr, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    const path = url.pathname.toLowerCase();
    if (path.endsWith('.pdf')) return true;
    const contentType = (url.searchParams.get('content_type') ?? '').toLowerCase();
    return contentType.includes('application/pdf');
  } catch {
    return urlStr.toLowerCase().includes('.pdf');
  }
}
